import type { CustomField } from '__types__';
import { normalizeCustomFieldWorkspaceId } from 'v5/core/custom-fields/resolveCustomFieldValue';

/** The columns of a `custom_fields` row that decide whether it is a workspace override. */
export type OverrideCandidateRow = Pick<
  CustomField,
  'custom_field_definition_id' | 'enterprise_workspace_id'
> &
  Partial<Pick<CustomField, 'archived'>>;

/**
 * workspaceId → definition ids that have a LIVE (`archived !== true`)
 * workspace-scoped `custom_fields` row. A blank row counts too: it hides
 * Global, as on the server. Global rows (`null`) never count.
 * Accepts a full `Resource` (structural `custom_fields`).
 */
export function collectOverrides(resource: {
  custom_fields: ReadonlyArray<OverrideCandidateRow>;
}): ReadonlyMap<number, ReadonlySet<number>> {
  const overrides = new Map<number, Set<number>>();
  for (const row of resource.custom_fields) {
    if (row.archived === true) continue;
    const workspaceId = normalizeCustomFieldWorkspaceId(
      row.enterprise_workspace_id
    );
    if (workspaceId === null) continue;
    const definitionIds = overrides.get(workspaceId) ?? new Set<number>();
    definitionIds.add(row.custom_field_definition_id);
    overrides.set(workspaceId, definitionIds);
  }
  return overrides;
}
